import { render, staticRenderFns } from "./activityRecord.vue?vue&type=template&id=58a41448"
import script from "./activityRecord.vue?vue&type=script&lang=js"
export * from "./activityRecord.vue?vue&type=script&lang=js"
import style0 from "./activityRecord.vue?vue&type=style&index=0&id=58a41448&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports